import { atom } from "recoil";

export const getLogCFIT = atom({
  key: "getLogCFIT",
  default: [],
});

export const preAssesmentIsDone = atom({
  key: "preAssesmentIsDone",
  default: false,
});

export const cfitIsDone = atom({
  key: "cfitIsDone",
  default: false,
});

export const papikostikIsDone = atom({
  key: "papikostikIsDone",
  default: false,
});
